import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';

const SustainabilitySummary = t.type(
  {
    medal: nullable(t.string),
    globalScore: nullable(t.number),
    isExpired: t.boolean,
    validUntilDate: nullable(t.string),
    scorecardLink: nullable(t.string),
  },
  'SustainabilitySummary',
);

type SustainabilitySummary = t.TypeOf<typeof SustainabilitySummary>;
export { SustainabilitySummary };
